import React, {} from 'react';
import { LinkStyles, NoMatchContainer } from '../../theme';
import { Link } from '@mui/material';
import StartOverButton from '../StartOverButton';

type Props = {
    show: boolean;
    handleStartOver: () => void;
}

const NoMatch = ({ show, handleStartOver }:Props): JSX.Element => {
    if (!show) {
        return (<></>);
    }
    return (
        <>
            <NoMatchContainer>
                <h3 style={{ fontSize: '24px' }}>Sorry, we couldn't find a match.</h3>
                <div style={{ marginLeft: '1.5rem', fontSize: '20px' }}>
                    <p>
                        Try typing only the name of the insurance company without any additional information.
                    </p>
                    <p>
                        If your plan is still not found, try one of the below:
                    </p>
                    <ul>
                        <li>Calling your insurance and asking if they are in-network with <span style={LinkStyles}>Perlman Clinic - Tax ID: 20-2138632</span> or <span style={LinkStyles}>83-2310783</span>.</li>
                        <li>Emailing a picture of your insurance card to <Link href='mailto:billing@perlmanclinic.com' style={LinkStyles}>billing@perlmanclinic.com.</Link> We’ll get back to you on in-network status within 1 business day.</li>
                        <li>Calling our billing department at (858) 554-1212</li>
                    </ul>
                    <p>
                        We also accept patients on a cash-pay basis. Check out our self-pay pricing <Link href='https://perlmanclinic.com/pricing/' style={LinkStyles} target="new">here</Link>. If you do self-pay, we are happy to provide you notes and an itemized receipt so you can try to be reimbursed by your insurance company.
                    </p>
                </div>
            </NoMatchContainer>
            <StartOverButton handleStartOver={handleStartOver}/>
        </>
    );
};

export default NoMatch;
